import React from 'react';

export const ScreenLoading: React.FC<{ title: string; detail?: string; play?: boolean }> = ({
  title,
  detail,
  play = false,
}) => (
  <div className={play ? 'ss-play ss-play-skel' : 'ss-state'} role="status" aria-live="polite">
    <div className="ss-skeleton-block" />
    {play && (
      <>
        <div className="ss-skeleton-block" />
        <div className="ss-skeleton-block" />
      </>
    )}
    <p className="ss-state-title">{title}</p>
    {detail ? <p className="ss-sub">{detail}</p> : null}
    <div className="ss-skeleton-line" />
    <div className="ss-skeleton-line is-short" />
  </div>
);

export const ScreenError: React.FC<{ message: string; onHome: () => void }> = ({ message, onHome }) => (
  <div className="ss-sheet">
    <p className="ss-kicker">Room</p>
    <h1 className="ss-title">Could not load this game</h1>
    <p className="ss-error">{message}</p>
    <button type="button" className="ss-btn ss-btn-ghost" onClick={onHome}>
      Back home
    </button>
  </div>
);
